// Panel "Tu lugar" de la pantalla del partido cuando se entra con un link de gestión válido (T11).
// Presentacional: la pantalla padre (OpenMatchDetail) llama a /me, /leave y /cancel y le pasa el resultado.
// - Jugador que no es el creador: "Estás anotado" + "Bajarme del partido" con confirmación en línea.
// - Creador: "Creaste este partido" + "Cancelar partido" con confirmación en línea (la cancha se libera).
// - Bloqueado (cerró, ya no está abierto, ya se bajó): se muestra el motivo en castellano en lugar del botón.
// The title is the role line; the destructive trigger is an outlined danger button (secondary, not a primary CTA).
// La confirmación es en línea (sin window.confirm) y el token nunca llega acá: solo se renderizan estados.
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { leaveBlockedMessage } from "../openMatchesModel";

const OpenMatchPlayerPanel = ({ me, outcome, canRejoin, busy, error, onLeave, onCancel, onRejoin }) => {
	// "leave" | "cancel" | null: qué confirmación en línea está abierta.
	const [confirming, setConfirming] = useState(null);

	const gone = outcome === "left" || me.left || me.leaveBlockedReason === "not_a_player";
	const cancelledByMe = outcome === "cancelled";

	let title = "Estás anotado";
	if (me.isCreator) title = "Creaste este partido";
	if (gone) title = outcome === "left" || me.left ? "Te bajaste del partido" : "Ya no estás anotado en este partido";
	if (cancelledByMe) title = "Cancelaste el partido";

	const run = async (action) => {
		const ok = await action();
		if (ok !== false) setConfirming(null);
	};

	let body = null;
	if (cancelledByMe) {
		body = <p className="open-match-manage-note">La cancha quedó libre y avisamos a los jugadores.</p>;
	} else if (gone) {
		body = canRejoin ? (
			<div className="open-match-manage-actions">
				<button type="button" className="r-btn-soft" onClick={onRejoin}>
					Volver a sumarme
				</button>
			</div>
		) : null;
	} else if (me.canCancel) {
		body =
			confirming === "cancel" ? (
				<div className="open-match-manage-confirm" role="group" aria-label="Confirmar cancelación">
					<p>Si cancelás, la cancha se libera y avisamos a todos los jugadores. No se puede deshacer.</p>
					<div className="open-match-manage-actions">
						<button type="button" className="r-btn-danger" disabled={busy} onClick={() => run(onCancel)}>
							Sí, cancelar partido
						</button>
						<button type="button" className="r-btn-soft" disabled={busy} onClick={() => setConfirming(null)}>
							No, mantenerlo
						</button>
					</div>
				</div>
			) : (
				<div className="open-match-manage-actions">
					<button type="button" className="r-btn-outline-danger" onClick={() => setConfirming("cancel")}>
						Cancelar partido
					</button>
				</div>
			);
	} else if (me.canLeave) {
		body =
			confirming === "leave" ? (
				<div className="open-match-manage-confirm" role="group" aria-label="Confirmar baja">
					<p>Si te bajás, tu lugar queda libre para otro jugador.</p>
					<div className="open-match-manage-actions">
						<button type="button" className="r-btn-danger" disabled={busy} onClick={() => run(onLeave)}>
							Sí, bajarme
						</button>
						<button type="button" className="r-btn-soft" disabled={busy} onClick={() => setConfirming(null)}>
							No, quedarme
						</button>
					</div>
				</div>
			) : (
				<div className="open-match-manage-actions">
					<button type="button" className="r-btn-outline-danger" onClick={() => setConfirming("leave")}>
						Bajarme del partido
					</button>
				</div>
			);
	} else {
		body = (
			<p className="open-match-manage-note">
				{leaveBlockedMessage(me.leaveBlockedReason, { isCreator: me.isCreator })}
			</p>
		);
	}

	return (
		<section className="open-match-manage" data-testid="open-match-player-panel" aria-label="Tu lugar en el partido">
			<h2 className="open-match-manage-title">{title}</h2>
			{error && <Alert variant="danger">{error}</Alert>}
			{body}
		</section>
	);
};

export default OpenMatchPlayerPanel;
